let snapshot = {
    sortKey: '',
    pages: {},
};

const makeSortKey = (params = {}) => (
    [params.search || '', params.sortResult || '', params.sortOrder || '', params.max || 10].join('|')
);

const makeOffset = (params = {}) => String(parseInt(params.offset, 10) || 0);

export const clearAgentPayoutListSnapshot = () => {
    snapshot = {
        sortKey: '',
        pages: {},
    };
};

export const updateSnapshotAgentBalance = (agentId, currentBalance) => {
    Object.keys(snapshot.pages).forEach((offset) => {
        snapshot.pages[offset] = snapshot.pages[offset].map((agent) => (
            agent.agentId === agentId ? { ...agent, balance: currentBalance } : agent
        ));
    });
};

export const applyAgentPayoutPageSnapshot = (params, wallets) => {
    if (!wallets || !wallets.length) {
        return wallets;
    }

    const sortKey = makeSortKey(params);
    if (snapshot.sortKey !== sortKey) {
        snapshot = { sortKey, pages: {} };
    }

    const offset = makeOffset(params);

    if (snapshot.pages[offset]) {
        const liveById = {};
        wallets.forEach((wallet) => {
            liveById[wallet.agentId] = wallet;
        });

        const restored = snapshot.pages[offset].map((saved) => (
            liveById[saved.agentId] ? { ...saved, ...liveById[saved.agentId] } : saved
        ));

        const usedIds = new Set(restored.map((agent) => agent.agentId));
        wallets.forEach((wallet) => {
            if (!usedIds.has(wallet.agentId) && restored.length < wallets.length) {
                restored.push({ ...wallet });
                usedIds.add(wallet.agentId);
            }
        });

        snapshot.pages[offset] = restored;
        return restored;
    }

    snapshot.pages[offset] = wallets.map((wallet) => ({ ...wallet }));
    return snapshot.pages[offset];
};
